export default __webpack_public_path__ + "static/10_25-976d2ae1a2fb6be68fefa6e6ca4dec01.png";